// id контейнера, который скриншотим
export const screenshotTestContainerId = 'screenshotContainer';
// id поля ввода для конфига виджета выбора
export const idInputSelectWidgetConfig = 'selectorWidgetConfig';
